<template>
  <!-- <transition name="modal-fade"> -->
  <div
    class="mz-mask-in-game"
    :style="{
      position: itemData.position || 'absolute',
      top: itemData.pos.y + itemData.unit || '%',
      left: itemData.pos.x + itemData.unit || '%',
      background: itemData.background || 'transparent',
      width: itemData.width || '0',
      height: itemData.height || '0',
    }"
  >
    <img
      draggable="false"
      v-if="wrapState"
      :src="wrap"
      @click="uncoverWhatIsHidden()"
      :style="wrapStyle"
      class="wrap-image"
    />
  </div>
</template>
<script type="text/javascript">
import { Howler } from 'howler';
export default {
  name: 'mz-mask-in-game',
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    maskData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      wrap: null,
      wrapStyle: null,
      audioClick: null,
    };
  },
  watch: {},
  computed: {
    maskId() {
      return this.itemData.id;
    },
    wrapState() {
      let state = false,
        elem = this.maskData.find((el) => el.id == this.maskId);
      if (elem !== undefined) state = elem.isWrapped;
      return state;
    },
  },
  methods: {
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    uncoverWhatIsHidden() {
      if (this.itemData && this.itemData.click) {
        this.audioClick.play();
      }
      let newMaskData = this.maskData;
      newMaskData.find((el) => el.id == this.maskId).isWrapped = false;
      this.$emit('change-item-mask', { item: newMaskData });
    },
    setAudioConfig() {
      if (this.itemData && this.itemData.src) {
        this.wrap = this.giveMeImagePlease(this.itemData.src);
        this.wrapStyle = this.itemData?.cssStyle;
      }
      if (this.itemData && this.itemData.click) {
        this.audioClick = new Howl({
          src: this.giveMeImagePlease(this.itemData.click.src),
          autoplay: false,
          loop: false,
          volume: 0.5,
        });
      }
    },
  },
  beforeMount() {
    this.setAudioConfig();
  },
};
</script>

<style lang="sass" scoped>
.mz-mask-in-game
  display: inline-block
  z-index: 2
  background: white
  line-height: 0
  //box-shadow: 0vh 0vh 2vh 1vh rgba(0,0,0,0.34)
  .wrap-image
    position: absolute
    left: 0
    top: 0
    z-index: 2
  .play-stop, .stop-audio
    width: 100%
    height: 100%
    transform-origin: center
    path
    transform-origin: center
  svg
    transition: 0.5s
    path
    transition: 0.5s
  // .svg-button-on
    // transition: 0.5s
    // cursor: pointer
    // transform: scale(.8, .8)
    // &:hover
    //   transform: scale(1, 1)
  .icon-png
    cursor: pointer
    width: 100%
    height: 100%
    transition: 0.5s
    transform-origin: center
    // transform: scale(.8, .8)
    &:hover
      // transform: scale(1, 1)
    img
      transition: 0.5s
      position: absolute
      width: 100%
      height: 100%
      left: 0
      top: 0
@keyframes textMove
  48%
    left: -60vw
    opacity: 1
  49%
    left: -60vw
    opacity: 0
  50%
    left: 60vw
    opacity: 0
  51%
    opacity: 1
    left: 60vw

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: translateY(-20vh)
  opacity: 0
.click-fade-leave-active, .click-fade-enter-active
  transition: all .3s linear
.click-fade-leave-to, .click-fade-enter
  opacity: 0
</style>
<style lang="scss">
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/titleStyle';

.svg-button-on {
  color: $secondIconColor;
  background-color: $firstIconColor;
  transition: 0.2s;
  border-radius: 50%;
  &:hover {
    // background-color: rgb(40, 196, 36);
    color: $firstIconColor;
    background-color: $secondIconColor;
    // .audio-icon {
    //     color: $secondIconColor;
    //     background-color: $firstIconColor;
    // }
    path {
      fill: #00a8ec;
    }
  }
  path {
    width: 100%;
    height: 100%;
    fill: white;
    transition: 0.2s;
  }
}
</style>
